import React, { useState, useEffect } from "react";
import { Typography } from "@material-ui/core";
import { injectIntl } from "react-intl";

//@ts-ignore
import MainContent from "hcla-web-frontend-primitives/app/components/primitives/Views/MainContent";
import UseFilterKey, {
  frontendFilter,
} from "hcla-web-frontend-primitives/app/Utils/UseFilterKey";
import PhoenixApiManager from "../../Api/PhoenixApiManager";
import MainModelListView from "./MainModelListView";

const updatableDataInitStates: Partial<State> = {
  main_items: [],
  main_itemTotal: null,
  main_limit: null,
  main_offset: null,
  paginationEnabled: false,
  isLoading: true,
};

interface Props {
  intl: any;
  depth: number;
  history: { [key: string]: any };
  location: { [key: string]: any };
  match: { [key: string]: any };
}

interface State {
  main_items: any[];
  main_itemTotal?: number | null;
  main_limit?: number | null;
  main_offset?: number | null;
  paginationEnabled?: boolean | null;
  isLoading: boolean;
  sort: (i: any) => any;
}

class Models extends React.Component<Props, State> {
  localPagination = JSON.parse(localStorage.getItem("pagination"));
  isAutoPagination =
    !this.localPagination ||
    (this.localPagination &&
      this.localPagination.auto &&
      !this.localPagination.rowsPerPage);
  constructor(props: Props) {
    super(props);
    this.state = {
      main_items: [],
      main_itemTotal: null,
      main_limit: !this.isAutoPagination ? this.localPagination.rowsPerPage : null,
      main_offset: null,
      paginationEnabled: false,
      isLoading: true,
      sort: (i) => i,
    };
  }

  loadMainData = (filterKey?: string) => {
    const { main_limit, main_offset } = this.state;
    if (filterKey) {
      return PhoenixApiManager.searchMainModels(filterKey, main_limit, main_offset).then(
        (response) => {
          const { data } = response;
          this.setState({
            main_items: data && data.results ? data.results : data,
            main_itemTotal: data && data.count ? data.count : null,
            paginationEnabled: !!(data && data.results),
            isLoading: false,
          });
        }
      );
    } else {
      return PhoenixApiManager.getMainModels(main_limit, main_offset)
        .then((response) => response.json())
        .then((data) =>
          this.setState({
            main_items: data && data.results ? data.results : data,
            main_itemTotal: data && data.count ? data.count : null,
            paginationEnabled: !!(data && data.results),
            isLoading: false,
          })
        );
    }
  };

  loadAllData = () => {
    this.loadMainData();
  }

  searchMainModels = (filterKey?: string) => {
    const { main_limit, main_offset } = this.state;
    return this.setState(
      {
        main_offset: 0,
      },
      () => {
        return PhoenixApiManager.searchMainModels(
          filterKey,
          main_limit,
          main_offset
        ).then((response) => {
          const { data } = response;
          this.setState({
            main_items: data && data.results ? data.results : data,
            main_itemTotal: data && data.count ? data.count : null,
            paginationEnabled: !!(data && data.results),
            isLoading: false,
          });
        });
      }
    );
  };

  updateMainList = (filterKey?: string, main_limit?: number, main_offset?: number) => {
    this.setState({ main_limit, main_offset }, () => this.loadMainData(filterKey));
  };

  handleSortChange = (sort: any) => {
    this.setState({ ...this.state, sort });
    // todo: fetch data if pagination is enabled
  };

  render() {
    const {
      main_items,
      main_itemTotal,
      paginationEnabled,
      isLoading,
      sort,
    } = this.state;
    const { intl } = this.props;

    return (
      <UseFilterKey
        loadData={this.loadAllData}
        render={({ filterInput, handleFilterChange, handleFilterSubmit }: any) => (
          <MainContent>
              <MainModelListView
                items={sort(frontendFilter(main_items, filterInput))}
                itemTotal={main_itemTotal}
                paginationEnabled={paginationEnabled}
                updateList={(main_limit?: number, main_offset?: number) =>
                  this.updateMainList(filterInput, main_limit, main_offset)
                }
                isLoading={isLoading}
                title={
                  <Typography variant="h4" gutterBottom>
                    {intl.formatMessage({ id: "modelListTitle" })}
                  </Typography>
                }
                filterInput={filterInput}
                handleFilterChange={(e: any) => {
                  handleFilterChange(e);
                  this.searchMainModels(e.target.value);
                }}
                handleFilterSubmit={handleFilterSubmit}
                handleSortChange={this.handleSortChange}
              />
          </MainContent>
        )}
      />
    );
  }
}

export default injectIntl(Models);
